export default function Light() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none">
            <path
                d="M12.2093 8.2737L7.26329 8.74069L8.00539 0L0 14.0834L4.72973 13.4546L3.6832 21.5116L12.2093 8.2737Z"
                fill="url(#paint0_linear_2927_55485)"
            />
            <defs>
                <linearGradient id="paint0_linear_2927_55485" x1="12.4484" y1="26.7963" x2="-4.71843" y2="26.4357" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0161916" stopColor="#EC8E1B" />
                    <stop offset="0.491691" stopColor="#FBA11A" />
                    <stop offset="0.892701" stopColor="#FED03C" />
                </linearGradient>
            </defs>
        </svg>
    );
}
